'use client';

import { Input } from 'src/components';
import { cn } from 'src/lib/utils';

interface CaptchaInputProps {
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  placeholder?: string;
  captchaImage?: string;
  loading?: boolean;
  onRefreshCaptcha?: () => void;
}

export function CaptchaInput({
  value,
  onChange,
  className,
  placeholder,
  captchaImage,
  loading,
  onRefreshCaptcha,
}: CaptchaInputProps) {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <div className={cn('flex items-center space-x-2 w-full', className)}>
      <div className="flex-1">
        <Input
          type="text"
          value={value}
          onChange={handleInputChange}
          placeholder={placeholder || '请输入验证码'}
          maxLength={4}
        />
      </div>
      <div className="relative">
        {captchaImage && !loading ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={captchaImage}
            alt="验证码"
            className="h-10 w-32.5 border rounded cursor-pointer hover:opacity-80 transition-opacity"
            onClick={onRefreshCaptcha}
            title="点击刷新验证码"
          />
        ) : (
          <div
            className={cn(
              'h-10 w-32.5 border rounded bg-white flex items-center justify-center text-xs text-gray-500',
              loading && 'animate-pulse'
            )}
          >
            加载中...
          </div>
        )}
      </div>
    </div>
  );
}
